import { DeleteOutlineIcon, IconButton } from '@shared/components';

import { useRoleUserManagementModal } from '../../providers';

interface RoleUserDeletionButtonProps {
  userId: string;
}

export default function RoleUserDeletionButton(props: Readonly<RoleUserDeletionButtonProps>) {
  const { userId } = props;

  const { setAction } = useRoleUserManagementModal();

  const handleClick = () => {
    setAction('role-user-deletion', { userId });
  };

  return (
    <IconButton onClick={handleClick}>
      <DeleteOutlineIcon color='error' />
    </IconButton>
  );
}
